---
title: CGU
updated: 2026-10-02
---

## 1. Acceptation des Conditions

En créant un compte ou en utilisant Draughts Game (« le Service »), vous acceptez d'être lié par les présentes Conditions d'Utilisation. Si vous n'êtes pas d'accord, veuillez ne pas utiliser le Service.

## 2. Description du Service

Draughts Game est une plateforme en ligne pour jouer aux jeux de dames dans plusieurs variantes. Le Service comprend le matchmaking contre d'autres joueurs ou contre l'ordinateur, des tournois, des classements de joueurs, des problèmes tactiques et des fonctionnalités d'analyse de parties.

## 3. Inscription

Pour accéder à certaines fonctionnalités, vous devez créer un compte en fournissant un nom d'utilisateur, une adresse e-mail et un mot de passe. Vous devez vérifier votre adresse e-mail avant de pouvoir vous connecter. Vous êtes responsable de la confidentialité de vos identifiants. Vous pouvez également jouer en tant qu'invité sans inscription, avec des fonctionnalités limitées.

- Vous devez avoir au moins 16 ans pour créer un compte.
- Vous ne pouvez créer qu'un seul compte par personne.
- Vous êtes responsable de toute activité effectuée avec votre compte.

## 4. Conduite de l'Utilisateur

En utilisant le Service, vous vous engagez à ne pas :

- Utiliser une assistance externe (moteurs, solveurs) pendant les parties classées.
- Perdre intentionnellement des parties pour manipuler votre classement (sandbagging).
- Pratiquer la collusion avec d'autres joueurs lors des tournois.
- Harceler, menacer ou insulter d'autres utilisateurs.
- Créer plusieurs comptes pour contourner des bannissements ou manipuler les classements.
- Tenter d'exploiter des bugs ou des vulnérabilités de la plateforme.
- Utiliser des outils automatisés (bots) pour jouer sans autorisation.

## 5. Fair-play

Nous nous réservons le droit d'utiliser des systèmes automatisés pour détecter la triche et le jeu déloyal. Les violations peuvent entraîner des avertissements, des suspensions temporaires, des ajustements de classement ou des bannissements permanents, à notre discrétion.

## 6. Propriété Intellectuelle

Le Service, y compris son design, son code original, ses graphismes et son contenu, est la propriété de Draughts Game. Les enregistrements de parties (coups, résultats) sont des données publiques et peuvent être librement partagés. Le contenu généré par les utilisateurs (noms d'utilisateur, messages de chat) reste la propriété de leurs auteurs respectifs.

## 7. Disponibilité et Modifications

Nous nous efforçons de maintenir le Service disponible à tout moment, mais nous ne garantissons pas un accès ininterrompu. Nous nous réservons le droit de modifier, suspendre ou interrompre toute partie du Service à tout moment. Nous pouvons mettre à jour ces Conditions de temps à autre. L'utilisation continue du Service après des modifications vaut acceptation.

## 8. Limitation de Responsabilité

Le Service est fourni « tel quel », sans garantie d'aucune sorte, expresse ou implicite. Nous ne sommes pas responsables des dommages indirects, accessoires ou consécutifs résultant de votre utilisation du Service. Notre responsabilité totale ne dépassera pas le montant que vous nous avez payé au cours des 12 mois précédant la réclamation (le cas échéant).

## 9. Résiliation

Vous pouvez supprimer votre compte à tout moment depuis les paramètres de votre profil (« Supprimer le compte ») ou en nous contactant. Nous pouvons résilier ou suspendre votre compte si vous violez ces Conditions ou adoptez un comportement nuisible au Service ou aux autres utilisateurs.

## 10. Contact

Pour toute question concernant ces Conditions, contactez-nous à : [legal@draughtsgame.com](mailto:legal@draughtsgame.com)
